<script setup lang="ts">
  // import '../../assets/styles/main.scss';
  import '../../assets/styles/main.scss';

  defineProps({
    homepage: Object,
  });
</script>
<template>
  <HeaderContainer v-bind="{ homepage }" />
  <slot />
  <FazFooter />
  <SfToastsManager />
  <SfProgressLoader />
</template>
